<template>
  <div>
    <el-row :gutter="4" style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;background-color: blue">
      <el-col :span="4"></el-col>
      <el-col :span="14" style="text-align: center;">
        <div style="font-size: 30px; font-weight: bold;vertical-align: center;color: white">中级消防设施操作员[理论题]练习
          {{ paperInfo.name }}
        </div>
        <div style="font-size: 16px; color: gray;vertical-align: center;color: white">题目类型:{{ paperDetailInfo.name }}
          第{{ questionNumber }}题/共{{ paperDetailInfo.totalCount }}题
          答题时间:{{ paperDetailInfo.limitTime }}分钟
        </div>
      </el-col>
      <el-col :span="6">
        <el-menu mode="horizontal">
          <el-sub-menu index="1">
            <template #title>
              <div style="font-size: 20px;border-bottom-color: transparent;">欢迎 {{ loginNickName }}</div>
            </template>
            <el-menu-item @click="handleToPage('/')" index="home">首页</el-menu-item>
            <el-menu-item v-if="!isBuy" @click="handleToTryPractice('/fire/try/practice/theoryMediumDevice','try', 'practice','theory')" index="theoryPracticeTry">理论练习</el-menu-item>
            <el-menu-item v-if="!isBuy" @click="handleToTryPractice('/fire/try/exam/theoryMediumDevice','try', 'exam','theory')" index="theoryExamTry">模拟理论考试</el-menu-item>
            <el-menu-item v-if="!isBuy" @click="handleToTryPractice('/fire/try/practice/peopleMediumDevice','try', 'practice','people')" index="peoplePracticeTry">操作题练习</el-menu-item>
            <el-menu-item v-if="!isBuy" @click="handleToTryPractice('/fire/try/exam/peopleMediumDevice','try', 'exam','people')" index="peoplePracticeTry">操作题考试</el-menu-item>
            <el-menu-item v-if="isBuy" @click="handleToTryPractice('/fire/normal/practice/theoryMediumDevice','normal', 'practice','theory')" index="theoryPractice">理论练习</el-menu-item>
            <el-menu-item v-if="isBuy" @click="handleToTryPractice('/fire/normal/exam/theoryMediumDevice','normal', 'exam','theory')" index="theoryExam">模拟理论考试</el-menu-item>
            <el-menu-item v-if="isBuy" @click="handleToTryPractice('/fire/normal/practice/peopleMediumDevice','normal', 'practice','people')" index="peoplePractice">操作题练习</el-menu-item>
            <el-menu-item v-if="isBuy" @click="handleToTryPractice('/fire/normal/exam/peopleMediumDevice','normal', 'exam','people')" index="peopleExam">操作题考试</el-menu-item>

          </el-sub-menu>
        </el-menu>
      </el-col>
    </el-row>

    <div>
      <el-row>
        <el-col :span="4" style="height:600px;overflow-y:auto">
          <div
              style="border-left: 2px solid blue;padding-bottom: 5px;padding-top: 5px;">
            {{ paperDetailInfo.name }}(共{{ paperDetailInfo.totalCount }}题)
          </div>
          <div>
            <el-button v-for="index in paperDetailInfo.totalCount"
                       :key="index" :style="givenButtonStyle(index)"
                       @click="getGivenQuestion(paperInfo, index)">
              {{ index }}
            </el-button>
          </div>

        </el-col>
        <el-col :span="16">

          <el-card style="width: 100%">
            <div style="font-size: 18px;padding-bottom: 20px"> {{ questionNumber }}.{{
                paperContentInfo.question
              }}
            </div>
            <div v-if="paperContentInfo.type==='singleChoice'||paperContentInfo.type==='judgment'">
              <el-radio-group
                  v-for="(answerInfo,index) in paperContentInfo.questionAnswerDtoList"
                  :key="index"
                  v-model="userAnswer">
                <el-radio :label="answerInfo.alphabet"
                          @click="getCurrentChoice(answerInfo, paperContentInfo.type)">
                  {{ answerInfo.alphabet }}.{{ answerInfo.content }}&nbsp;&nbsp;
                </el-radio>
              </el-radio-group>
            </div>
            <div v-if="paperContentInfo.type==='multipleChoice'" style="display: flex;flex-wrap: wrap; ">
              <el-checkbox-group style="margin-right: 10px;" v-model="selectedAnswers">
                <el-checkbox :label="answerInfo" :value="answerInfo"
                             v-for="answerInfo in paperContentInfo.questionAnswerDtoList"
                             :key="answerInfo.id">
                  {{ answerInfo.alphabet }}.{{ answerInfo.content }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-card>
          <el-row v-if="hasSelected" style="padding-top: 20px;width: 100%;display: flex">
            <div v-if="!checkAnswerIsCorrect()" style="color:red; font-size: 18px;padding-left:20px;">回答错误 X</div>
            <div v-if="checkAnswerIsCorrect()" style="color:green;; font-size: 18px;padding-left:20px;">回答正确 √</div>

            <div style="padding-left: 20px; font-size: 18px">正确答案:</div>
            <span style="color: green; font-size: 18px">{{
                chooseAnswerInfo.correctAnswerAlphabet.toString().replaceAll(",", "")
              }} </span>
            <span style="padding-left: 20px; font-size: 18px">你的答案:</span>
            <span style="color:red;; font-size: 18px" v-for="selectedAnswer in sortSelectedAnswer" :key="selectedAnswer.questionId">
              {{ selectedAnswer.alphabet }}</span>
<!--            <el-button style="float:right;margin-left: 300px;height: 18px;border: none"-->
<!--                       @click="addUserCollection">-->
<!--                            <img :src="require(`@/assets/picture/userInfo/collection.png`)"-->
<!--                                 alt="collectionImg"-->
<!--                                 style="width: 18px;height: 18px">-->
<!--              收藏本题-->
<!--            </el-button>-->

            <el-card v-if="!checkAnswerIsCorrect()"
                     style="font-size: 18px;width: 100%">
              <span style="padding-top: 20px">参考解析：{{ paperContentInfo.analysisText }}</span>
            </el-card>
          </el-row>
          <div style="padding-top: 10px">
            <el-button round type="primary" style="float:left" v-if="questionNumber>1"
                       @click="getPreviousQuestion(paperInfo)">上一题
            </el-button>

            <el-button v-if="questionNumber<paperDetailInfo.totalCount" style="float:right;margin-right: 20px" round type="primary"
                       @click="getNextQuestion(paperInfo)">下一题
            </el-button>

            <el-button style="float:right;margin-right: 20px" round type="warning"
                       v-if="paperInfo.status === 'active'"  @click="addUserCollection">收藏本题
            </el-button>
          </div>
        </el-col>
        <el-col :span="4" style="font-size: 16px">
          <div style="padding-left: 40px;"><img :src="require(`@/assets/picture/FireEngine/studentHeadPicture.png`)"
                                                alt="headImg"
                                                style="width: 150px;height: 150px"></div>
          <div style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;">
            考生姓名:{{ loginNickName }}<br>
            身份证号:119**********888<br>
            网络状态：<span style="color: darkgreen">正常</span>
          </div>
          <div style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;padding-top:20px;">
            剩余时间:<span style="color: red">{{ remainingHours }}:{{ remainingMinutes }}:{{ remainingSeconds }}</span>
          </div>
          <div style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;padding-top: 20px;">当前进度
            <el-progress type="line" :percentage="percentage" color="orange"></el-progress>
          </div>
          <div style="font-size: 14px;color: red">注意:答题时间到后,若未点交卷,系统会自动提交考卷。请注意答题时间!</div>
          <el-button type="warning"  @click="goBack()">返回</el-button>
          <el-button type="info" v-if="paperInfo.status === 'active'" @click="feedBack()">反馈</el-button>

        </el-col>

      </el-row>
    </div>
    <el-dialog v-model="showFeedBack" title="反馈" append-to-body>
      <feedBackComponent :questionId="questionId" :areaId="areaId" :paperId="paperId" :questionType="questionType" @submitFeedBack:value="handleFeedBackDialog"></feedBackComponent>
    </el-dialog>
  </div>


</template>

<script>
import {useRoute} from "vue-router/dist/vue-router";
import request from "@/utils/request";
import {ElMessage} from "element-plus";
import router from "@/router";
import {onMounted, onUnmounted, ref} from "vue";
import feedBackComponent from "@/components/FeedBack";


const loginNickName = localStorage.getItem("loginNickName");
const loginUserId = localStorage.getItem("loginUserId");

const questionNumber = ref(1);
const chooseAnswerInfo = ref({
  questionId: '',
  answer: true,
  alphabet: '',
  correctAnswerAlphabet: ''
});

const paperId=ref('');

const hasSelected = ref(false);

const percentage = ref(0);
const paperTotalCount = ref(0);
const questionType = ref('');

const selectedAnswers = ref([]);

const selectedQuestions = ref([]);
const givenButtonColor = ref([]);
const isBuy=ref(false);
const paperFontSize = ref('18px');

function getPaperDetailInfoByRandomExam(questionType, status) {
  request.get('/paperDetailInfo/randomExam',
      {
        params: {
          userId: loginUserId, questionType: questionType, type:status
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperDetailInfo = result.data;
          paperTotalCount.value = this.paperDetailInfo.totalCount;
          for (let i = 0; i < paperTotalCount.value; i++) {
            givenButtonColor.value.push("light-gray");
          }
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getPaperContentByRandomExam(questionType, status){
  request.get('/paperContentInfo/randomExam/one',
      {
        params:{
          userId: loginUserId, questionType: questionType, type:status,questionNumber:questionNumber.value, subjectId:this.paperInfo.subjectId
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperContentInfo = result.data;
          questionId.value=this.paperContentInfo.id;
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getPaperContentByUserQuestion(questionType, status){
  request.get('/userQuestionInfo/paperContentInfo/one',
      {
        params:{
          userId: loginUserId, questionType: questionType, type:status,questionNumber:questionNumber.value
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperContentInfo = result.data;
          questionId.value=this.paperContentInfo.id;
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getPaperContentByExamId(examId){
  request.get('/userQuestionInfo/paperContentInfo/exam',
      {
        params:{
          userId: loginUserId, examId:examId,questionNumber:questionNumber.value
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperContentInfo = result.data;
          questionId.value=this.paperContentInfo.id;
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}
function getPaperDetailInfoByQuestionId(questionType, status) {
  request.get('/userQuestionInfo/paperDetail',
      {
        params: {
          userId: loginUserId, questionType: questionType, type:status
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperDetailInfo = result.data;
          paperTotalCount.value = this.paperDetailInfo.totalCount;
          if(paperTotalCount.value===0){
            if(status==='error'){
              ElMessage.warning("您还没有生成此类型题目，错题在考试后自动生成")
            }
            if(status==='collection'){
              ElMessage.warning("您还没有生成此类型题目，收藏题需手动添加")
            }
            if(status==='userDefine'){
              ElMessage.warning("您还没有生成此类型题目，自定义题库需在反馈页面中增加新题")
            }
            this.goBack();
          }
          for (let i = 0; i < paperTotalCount.value; i++) {
            givenButtonColor.value.push("light-gray");
          }
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getPaperDetailInfoByExamId(examId) {
  request.get('/userQuestionInfo/paperDetail/exam',
      {
        params: {
          userId: loginUserId,
          examId:examId
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperDetailInfo = result.data;
          paperTotalCount.value = this.paperDetailInfo.totalCount;
          for (let i = 0; i < paperTotalCount.value; i++) {
            givenButtonColor.value.push("light-gray");
          }
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getPaperDetailInfoByEasyError(questionType, status) {
  request.get('/paperContentQuestionInfo/getPaperDetailByEasyError',
      {
        params: {
          userId: loginUserId, questionType: questionType, type:status
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperDetailInfo = result.data;
          paperTotalCount.value = this.paperDetailInfo.totalCount;
          for (let i = 0; i < paperTotalCount.value; i++) {
            givenButtonColor.value.push("light-gray");
          }
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getPaperContentInfoByEasyErrorQuestion( questionType, status){
  request.get('/paperContentInfo/easyError/one',
      {
        params: {
          userId: loginUserId, questionType: questionType, type:status, questionNumber:questionNumber.value
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperContentInfo = result.data;
          questionId.value=this.paperContentInfo.id;
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getUserAuthorization(paperId) {
  request.get('/userAuthorization/check',
      {params:{
          userId: loginUserId, paperId:paperId, type:"subject"
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          isBuy.value=result.data.checked;
        } else {
          ElMessage.warning(result.msg);
          router.push("/buyPage");
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function addUserCollectionInfo(paperId, subjectId, questionId, questionType) {
  request.post('/userQuestionInfo/',
      {
          userId: loginUserId, paperId: paperId, subjectId:subjectId,questionId: questionId, type:"collection",questionType:questionType
      },{
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          ElMessage.info("收藏成功")
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getPaperContentInfo(paperId, questionNumberId, paperType) {
  request.get('/paperContentInfo/one',
      {
        params: {
          userId: loginUserId, paperId: paperId, questionNumber: questionNumberId, paperType: paperType
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperContentInfo = result.data;
          questionId.value=this.paperContentInfo.id;
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

async function getPaperInfo(paperId) {
  await request.get('/paperInfo/paperId',
      {
        params: {
          userId: loginUserId, paperId: paperId
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperInfo = result.data;
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getPaperDetailInfo(paperId, paperType) {
  request.get('/paperDetailInfo/type',
      {
        params: {
          userId: loginUserId, paperId: paperId, paperType: paperType
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperDetailInfo = result.data;
          paperTotalCount.value = this.paperDetailInfo.totalCount;
          for (let i = 0; i < paperTotalCount.value; i++) {
            givenButtonColor.value.push("light-gray");
          }
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}


async function getPaperDetailInfoByFeedBack(questionType) {
  await request.get('/feedBackInfo/paperDetail',
      {
        params: {
          userId: loginUserId, areaId: areaId.value, questionType: questionType
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperDetailInfo = result.data;
          paperTotalCount.value = this.paperDetailInfo.totalCount;
          if(paperTotalCount.value===0){
            ElMessage.warning("您还没有生成此类型题目，反馈题目在反馈页面生成");
            this.goBack();
          }
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("paperDetailInfo error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

async function getPaperContentByFeedBack(questionType) {
  await request.get('/paperContentInfo/feedback/one',
      {
        params: {
          userId: loginUserId, questionNumber: questionNumber.value, questionType: questionType, areaId:areaId.value
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperContentInfo = result.data;
          questionId.value = this.paperContentInfo.id;
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

const remainingTime = ref(7200); // 2小时 = 7200秒
const remainingHours = ref("02");
const remainingMinutes = ref("00");
const remainingSeconds = ref("00");

const sortSelectedAnswer = ref([]);

const showFeedBack=ref(false);

const areaId=ref('');
const questionId= ref(0);

function getHasSelected(answerInfo) {
  if (questionType.value === 'singleChoice' || questionType.value === 'judgment') {
    return true;
  }
  sortSelectedAnswer.value = [...selectedAnswers.value].sort((a, b) => a.alphabet.localeCompare(b.alphabet))
  if (!chooseAnswerInfo.value.answer) {
    return true;
  }

  let correctAnswerString = answerInfo.correctAnswerAlphabet.toString().replaceAll(",", "")

  if (selectedAnswers.value.length >= correctAnswerString.length) {
    return true;
  }
  return selectedAnswers.value.some((element) => element.answer === false);
}


function getTimeString(number) {
  if(number<10){
    return "0"+number;
  }else{
    return number;
  }
}

export default {
  components: {feedBackComponent},
  name: "TheoryPaperPractice",
  data() {
    return {
      loginNickName: loginNickName,
      paperInfo: '',
      paperDetailInfo: '',
      paperContentInfo: '',
      userAnswer: '',
      chooseAnswerInfo: chooseAnswerInfo,
      hasSelected: hasSelected,
      questionNumber: questionNumber,
      remainingHours: remainingHours,
      remainingMinutes: remainingMinutes,
      remainingSeconds: remainingSeconds,
      percentage: percentage,
      selectedAnswers: selectedAnswers,
      sortSelectedAnswer: sortSelectedAnswer,
      givenButtonColor: givenButtonColor ,
      isBuy:isBuy,
      paperFontSize:paperFontSize,
      showFeedBack:showFeedBack,
      paperId:paperId,
      areaId:areaId,
      questionId:questionId,
      questionType:questionType,
    }
  },
  setup() {
    onMounted(() => {
      const intervalId = setInterval(() => {
        if (remainingTime.value > 0) {
          remainingTime.value -= 1;
          remainingHours.value=getTimeString(Math.floor(remainingTime.value / 3600));
          remainingMinutes.value = getTimeString(Math.floor((remainingTime.value % 3600) / 60));
          remainingSeconds.value = getTimeString(Math.floor(remainingTime.value % 60));
        } else {
          clearInterval(intervalId);
        }
      }, 1000);
      // 清除定时器
      onUnmounted(() => {
        clearInterval(intervalId);
      });
    });
  },
  async created() {
    const route = useRoute();

    if(route.query.examId!=null){
      getPaperDetailInfoByExamId.call(this, route.query.examId)
      getPaperContentByExamId.call(this, route.query.examId)

      this.userAnswer = null;
      this.selectedAnswers = ref([]);
      hasSelected.value = false;
      this.givenButtonColor = [];
      return;
    }

    paperId.value=route.query.paperId;
    questionNumber.value = parseInt(route.query.questionNumber, 10);
    questionType.value = route.query.questionType;
    areaId.value=route.query.areaId;

    this.getUserAuthorization(paperId.value);
    await this.getPaperInfo(paperId.value);

    if (this.paperInfo.status === 'active') {
      this.getPaperDetailInfo(paperId.value, questionType.value);
      this.getPaperContentInfo(paperId.value, questionType.value);
    }
    if(this.paperInfo.status==='error'|| this.paperInfo.status==='collection' ||this.paperInfo.status==='userDefine'){
      getPaperDetailInfoByQuestionId.call(this, questionType.value, this.paperInfo.status)
      getPaperContentByUserQuestion.call(this, questionType.value, this.paperInfo.status)
    }
    if(this.paperInfo.status==='easyError'){
      getPaperDetailInfoByEasyError.call(this, questionType.value, this.paperInfo.status)
      getPaperContentInfoByEasyErrorQuestion.call(this,  questionType.value, this.paperInfo.status)
    }
    if(this.paperInfo.status==='randomExam'){
      getPaperDetailInfoByRandomExam.call(this, questionType.value, this.paperInfo.status)
      getPaperContentByRandomExam.call(this,  questionType.value, this.paperInfo.status)
    }
    if(this.paperInfo.status==='feedBack'){
      await getPaperDetailInfoByFeedBack.call(this, questionType.value)
      await getPaperContentByFeedBack.call(this, questionType.value)
    }
    this.userAnswer = null;
    this.selectedAnswers = ref([]);
    hasSelected.value = false;
    this.givenButtonColor = [];
  },
  methods: {
    handleToPage(path) {
      router.push(path);
    },
    handleToTryPractice(trainPath, buyMode, studyMode){
      router.push({path:trainPath,query:{areaId: 13, studyMode: studyMode, buyMode:buyMode, subjectType:'theory'}});
    },
    getUserAuthorization(paperId){
      getUserAuthorization.call(this,paperId)
    },
    async getPaperInfo(paperId) {
      await getPaperInfo.call(this, paperId);
    },
    getPaperDetailInfo(paperId, questionType) {
      getPaperDetailInfo.call(this, paperId, questionType);
    },
    getPaperContentInfo(paperId, questionType) {
      getPaperContentInfo.call(this, paperId, questionNumber.value, questionType)
    },
    getCurrentChoice(answerInfo, questionType) {
      chooseAnswerInfo.value = answerInfo;
      if (questionType === 'singleChoice' || questionType === 'judgment') {
        sortSelectedAnswer.value = [answerInfo];
      }
      hasSelected.value = getHasSelected(answerInfo);
      const selectedQuestion = selectedQuestions.value.find(item => item.questionNumber === questionNumber.value);
      if (selectedQuestion) {
        selectedQuestion.isCorrect = answerInfo.answer;
        selectedQuestion.answerInfos = [answerInfo];
      } else {
        selectedQuestions.value.push({
          "questionNumber": questionNumber.value,
          "isCorrect": answerInfo.answer,
          "answerInfos": [answerInfo]
        });
      }
      this.changeGivenButtonColor(questionNumber.value);
      percentage.value = Math.floor((selectedQuestions.value.length / paperTotalCount.value) * 100);
    },
    getNextQuestion(paperInfo) {
      questionNumber.value = questionNumber.value + 1;
      this.getPaperContentInfoByStatus(paperInfo);
    },
    getPreviousQuestion(paperInfo) {
      questionNumber.value = questionNumber.value - 1;
      this.getPaperContentInfoByStatus(paperInfo);
    },
    getGivenQuestion(paperInfo, index) {
      questionNumber.value = index;
      this.getPaperContentInfoByStatus(paperInfo);
    },
    getPaperContentInfoByStatus(paperInfo) {
      this.userAnswer = null;
      this.selectedAnswers = ref([]);
      hasSelected.value = false;
      if (paperInfo.status === 'active') {
        getPaperContentInfo.call(this, paperInfo.id, questionNumber.value, questionType.value);
      }
      if (paperInfo.status === 'error' || paperInfo.status === 'collection') {
        getPaperContentByUserQuestion.call(this, questionType.value, paperInfo.status);
      }
      if (paperInfo.status === 'easyError') {
        getPaperContentInfoByEasyErrorQuestion.call(this, questionType.value, paperInfo.status);
      }

      if (paperInfo.status === 'randomExam') {
        getPaperContentByRandomExam.call(this, questionType.value, paperInfo.status);
      }
    },
    checkAnswerIsCorrect() {
      if (questionType.value === 'singleChoice' || questionType.value === 'judgment') {
        return chooseAnswerInfo.value.answer;
      }
      if (!chooseAnswerInfo.value.answer) {
        return false
      }
      let correctAnswerString = chooseAnswerInfo.value.correctAnswerAlphabet.toString().replaceAll(",", "")
      if (selectedAnswers.value.length > correctAnswerString.length) {
        return false;
      }
      if (selectedAnswers.value.length === correctAnswerString.length) {
        return selectedAnswers.value.every((element) => element.answer === true);
      }
      return false;
    },
    changeGivenButtonColor(index) {
      const selectQuestion = selectedQuestions.value.find(item => item.questionNumber === index);
      if (selectQuestion) {
        this.givenButtonColor[index - 1] = selectQuestion.isCorrect ? "skyblue" : "pink";
      }
    },
    givenButtonStyle(index) {
      return {
        "float": "left",
        "margin-left": 0,
        "margin-right": "3px",
        "margin-bottom": "3px",
        "width": "40px",
        "background-color": this.givenButtonColor[index - 1],
        "color": "black"
      }
    },
    addUserCollection() {
      addUserCollectionInfo.call(this,this.paperInfo.id, this.paperInfo.subjectId, this.paperContentInfo.id, this.paperContentInfo.type)
    },
    goBack() {
      if(isBuy.value){
        this.handleToTryPractice('/fire/normal/practice/TheoryMediumDevice','normal', 'practice');
      }
      else {
        this.handleToTryPractice('/fire/try/practice/TheoryMediumDevice','try', 'practice');
      }
    },
    feedBack(){
      showFeedBack.value=true;
    },
    handleFeedBackDialog(value){
      if(value==='success'){
        showFeedBack.value=false;
      }
    }
  },
  watch: {
    selectedAnswers: {
      handler(newValue) {
        if (newValue.length !== 0) {
          chooseAnswerInfo.value = newValue[newValue.length - 1];
          selectedAnswers.value = newValue;

          hasSelected.value = getHasSelected(chooseAnswerInfo.value);
          const selectedQuestion = selectedQuestions.value.find(item => item.questionNumber === questionNumber.value);
          if (selectedQuestion) {
            selectedQuestion.isCorrect = this.checkAnswerIsCorrect();
            selectedQuestion.answerInfos = newValue;
          } else {
            selectedQuestions.value.push({
              "questionNumber": questionNumber.value,
              "isCorrect": this.checkAnswerIsCorrect(),
              "answerInfos": newValue
            });
          }
          this.changeGivenButtonColor(questionNumber.value);
          percentage.value = Math.floor((selectedQuestions.value.length / paperTotalCount.value) * 100);
        }
      }
    }
  }
}
</script>

<style scoped>
.mode-col {
  height: 300px;
  width: 400px; /* 设置一个高度让背景显示出来 */
  background-size: contain;
  background-repeat: no-repeat; /* 背景图片覆盖整个元素 */
  transition: background-image 0.5s; /* 可选的，背景图变化过渡效果 */
  align-content: center;
  /*background-color: lightgray;*/
}

.el-menu {
  background-color: transparent;
  border-bottom-color: transparent;
}

.el-menu-item {
  background-color: transparent !important;
  color: black !important;
  font-weight: 50;
  width: 200px;
  font-size: 18px;
  text-align: center;
&:not(.is-disabled):hover {
   color: gray !important;
   background-color: lightgray !important;
   width: 200px;
   text-align: center;
 }
}
.content {
  flex: 1; /* 让内部容器充满剩余空间 */
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: flex-start; /* 水平方向从左边开始排列 */
}


.el-radio :deep(.el-radio__label) {
  font-size: v-bind(paperFontSize);
  line-height: 2;
  color: black;
  margin-right: 15px;
}

.el-radio :deep( .el-radio__inner) {
  width: 18px;
  height: 18px;
  border-color: black;
}

/*.el-radio /deep/.el-radio__input.is-checked .el-radio__inner::after {*/
/*  !* 更改圆点颜色 *!*/
/*  background-color: black; !* 例子中使用了红色 *!*/
/*}*/

.el-radio :deep(.el-radio__input.is-checked + .el-radio__label) {
  color: black;
}
.el-radio  :deep(.el-radio__input.is-checked .el-radio__inner) {
  border-color: gray; /* 选中边框的颜色 */
  background-color:gray; /* 选中背景的颜色 */
}

.el-checkbox :deep(.el-checkbox__label) {
  font-size: v-bind(paperFontSize);/* 这里设置你想要的字体大小 */
  overflow: hidden;
  white-space: normal;
  word-break: break-all;
  color:black;
}

.el-checkbox :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: black; /* 替换为你想要的颜色 */
}

.el-checkbox :deep(.el-checkbox__inner) {
  width: 16px; /* 修改选框的宽度 */
  height: 16px; /* 修改选框的高度 */
  border-color: black;
}

.el-checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner),
.el-checkbox :deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background-color: black; /* 你想要的选中颜色 */
  border-color: black;
}

/* 修改选中时的对勾颜色 */
.el-checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner::after) {
  color: black; /* 对勾颜色 */
}

</style>
